import type { Toast } from "../types"
import * as constants from '../constants'
import { VEC2, type AABB, sgt, smoothstep, VEC3, Vector, slt, clamp } from "math"
import type { Ref } from "vue"

export const getToastElapsed = (toast: Toast) => {
  const created = toast.timeCreated.getTime() / 1000
  const now = new Date().getTime() / 1000
  const elapsed = now - created
  return elapsed
}

export const getToastDuration = (toast: Toast) => {
  return toast.duration || constants.TOAST_DEFAULT_DURATION
}

export const getToastBound = (toast: Toast): AABB => {
  const margin = VEC2(constants.TOAST_MARGIN, constants.TOAST_MARGIN)
  const min = toast.position.sub(margin)
  const max = min
    .add(
      VEC2(
        Math.max(constants.TOAST_MIN_WIDTH, toast.width),
        Math.max(constants.TOAST_MIN_HEIGHT, toast.height)
      )
    )
    .add(margin)
  return { min, max }
}

export const getToastEnvelope = (toast: Toast) => {
  const elapsed = getToastElapsed(toast)
  const duration = getToastDuration(toast);

  const n = clamp(elapsed / duration, 0, 1);
  const an = 1.0-Math.abs(n*2.0-1.0);

  const justStarted = slt(elapsed, 0.01, 0.01);
  const halfWay = smoothstep(0.5, 1.0 + 0.1, an);
  const almostDone = sgt(elapsed, duration-0.15, 0.01);

  return VEC3(justStarted, halfWay, almostDone);
}

export const toastAddImpulse = (toast: Ref<Toast>, imp: Vector) => {
  toast.value.velocity = toast.value.velocity.add(imp.scale(toast.value.invMass));
}

export const toastAddPseudoImpulse = (toast: Ref<Toast>, imp: Vector) => {
  toast.value.position = toast.value.position.add(imp);
}
